import getProjects from '../api';

export const fetchProjects = () => {
  return dispatch => {
    dispatch({ type: 'PROJECTS:REQUEST' });
    return getProjects()
      .then(response => {
        dispatch({ type: 'PROJECTS:SUCCESS', payload: response });
      })
      .catch(err => {
        dispatch({ type: 'PROJECTS:ERROR', payload: err });
      });
  };
};

export const setActiveProject = project => {
  return {
    type: 'PROJECT:SET_ACTIVE',
    payload: { project },
  };
};

export const requestTabChange = tab => {
  return {
    type: 'TAB:ASKED_TO_LEAVE',
    payload: { tab },
  };
};

export const confirmTabChange = () => {
  return {
    type: 'TAB:IS_READY_TO_LEAVE',
    payload: { isReady: true },
  };
};



// WEBPACK FOOTER //
// ./src/actions/index.js